import { logEvent } from 'firebase/analytics'
import { analytics } from './firebase'

export const trackEvent = (name, params = {}) => {
  logEvent(analytics, name, params)
}
